import React, { useState } from "react";
import axios from "axios";


const useStaffStatisticsGender = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getStaffStatisticsGenderData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/organization_structure/api/staff/statistics_gender', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postStaffStatisticsGenderData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/organization_structure/api/staff/statistics_gender',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchStaffStatisticsGenderData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/organization_structure/api/staff/statistics_gender',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteStaffStatisticsGenderData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/organization_structure/api/staff/statistics_gender',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        StaffStatisticsGenderData: data,
        getStaffStatisticsGenderData,
        postStaffStatisticsGenderData,
        patchStaffStatisticsGenderData,
        deleteStaffStatisticsGenderData,
    }
}
export { useStaffStatisticsGender }
